module.exports = __webpack_public_path__ + "img/bird-10-left.c28b56f7.png";